import * as React from 'react';
import * as b_ from 'b_';
import cn from 'classnames';

import './index.scss';

interface Props extends React.SVGAttributes<SVGElement> {}

const b = b_.with('icon-telegram');

export const TelegramIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg className={cn(b(), className)} viewBox="0 0 29 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.8304 15.9608L11.3672 22.4755C12.0299 22.4755 12.3169 22.1908 12.6611 21.849L15.7679 18.8798L22.2056 23.5943C23.3862 24.2523 24.2181 23.9058 24.5366 22.5082L28.7622 2.70749L28.7634 2.70633C29.1379 0.960993 28.1322 0.278493 26.9819 0.706659L2.14356 10.2162C0.448397 10.8742 0.474063 11.8192 1.8554 12.2473L8.20556 14.2225L22.9557 4.99299C23.6499 4.53333 24.2811 4.78766 23.7619 5.24733L11.8304 15.9608Z" />
    </svg>
  );
};
